import { createWindowFunctionCondition } from './core';
import { WorkflowProcesses } from './core/MocksTypes';

/* Define here workflows */
/*
const workflowName:WorkflowProcesses = {
    params: {object} Params to override process steps data.
    globalData: {object} Data to share between processes
    processes: {array} (required) List of process to execute
}
*/

// startCondition: 'GET INSTRUMENT_HEIGHT REQUEST',
const instrumentHeightWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'instrumentHeight',
            startCondition: createWindowFunctionCondition('instrumentHeight'),
            finishCondition: 'GET INSTRUMENT_HEIGHT RESPONSE',
        },
    ],
};

const instrumentHeightWorkflowFail: WorkflowProcesses = {
    processes: [
        {
            process: 'instrumentHeightFail',
            startCondition: createWindowFunctionCondition('instrumentHeightFail'),
            finishCondition: 'GET INSTRUMENT_HEIGHT RESPONSE',
        },
    ],
};

const stationPositionWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'stationPosition',
            startCondition: createWindowFunctionCondition('getStationPosition'),
            finishCondition: 'GET STATION_POSITION RESPONSE',
        },
    ],
};

const userPreferencesWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'requestUserPreferences',
            startCondition: createWindowFunctionCondition('requestUserPreferences'),
            finishCondition: 'GET USER_PREFERENCES RESPONSE',
        },
    ],
};

const boundingWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'requestBounding',
            startCondition: createWindowFunctionCondition('requestBounding'),
            finishCondition: 'GET PROJECT_DATA RESPONSE',
        },
    ],
};

const pivotPointWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'requestPivotPoint',
            startCondition: createWindowFunctionCondition('requestPivotPoint'),
            finishCondition: 'GET PROJECT_DATA RESPONSE',
        },
    ],
};

const projectNameWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'requestProjectName',
            startCondition: createWindowFunctionCondition('requestProjectName'),
            finishCondition: 'GET PROJECT_DATA RESPONSE',
        },
    ],
};

const projectDataWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'requestProjectData',
            startCondition: createWindowFunctionCondition('requestProjectData'),
            finishCondition: 'GET PROJECT_DATA RESPONSE',
        },
    ],
};

const notifyWorkflowStateWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'notifyWorkflowState',
            startCondition: createWindowFunctionCondition('notifyWorkflowState'),
            finishCondition: 'SET WORKFLOW_STATE RESPONSE',
        },
    ],
};

const waitForNotifyWorkflowStateWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'waitForNotifyWorkflowState',
            startCondition: createWindowFunctionCondition('waitForNotifyWorkflowState'),
            finishCondition: 'SET WORKFLOW_STATE RESPONSE',
        },
        // Use next line to test getting continuous state changes events (In addition, you should comment line 76 this.subsHandler.cancel(); in Step.js)
        //{ process: 'waitForNotifyWorkflowState', startCondition: createWindowFunctionCondition( 'waitForNotifyWorkflowState' ), finishCondition: createWindowFunctionCondition( 'stopWaitForState' ) },
    ],
};

const notifyScannerStateWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'notifyScannerState',
            startCondition: createWindowFunctionCondition('notifyScannerState'),
            finishCondition: 'SET SCANNER_STATE RESPONSE',
        },
    ],
};
const notifyScannerStateWorkflowFail: WorkflowProcesses = {
    processes: [
        {
            process: 'notifyScannerStateFail',
            startCondition: createWindowFunctionCondition('notifyScannerStateFail'),
            finishCondition: 'SET SCANNER_STATE RESPONSE',
        },
    ],
};
const getScannerStateWorkflow: WorkflowProcesses = {
    processes: [{ process: 'getScannerState', startCondition: 'GET SCANNER_STATE REQUEST', finishCondition: 'GET SCANNER_STATE RESPONSE' }],
};

const addNewStationWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'createNewStation',
            startCondition: 'CREATE NEW_STATION REQUEST',
            finishCondition: 'CREATE NEW_STATION RESPONSE',
            blockUntilFinish: true,
        },
    ],
};
// to use this method, comment the previous one or enableMocks after clicking on ADD NEW STATION button
const addNewStationManuallyWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'createNewStationManually',
            startCondition: createWindowFunctionCondition('newStation'),
            finishCondition: 'CREATE NEW_STATION RESPONSE',
            blockUntilFinish: true,
        },
    ],
};

const addNewStationWorkflowFail: WorkflowProcesses = {
    processes: [
        {
            process: 'createNewStationFail',
            startCondition: createWindowFunctionCondition('newStationFail'),
            finishCondition: 'CREATE NEW_STATION RESPONSE',
            blockUntilFinish: true,
        },
    ],
};

const addNewLayoutPoint: WorkflowProcesses = {
    processes: [
        {
            process: 'waitForLayoutPointRequest',
            startCondition: createWindowFunctionCondition('waitForLayoutPointRequest'),
            finishCondition: 'GET LAYOUT_POINT REQUEST',
        },
    ],
};

const waitForStandardVerification: WorkflowProcesses = {
    processes: [
        {
            process: 'getStandardVerification',
            startCondition: createWindowFunctionCondition('getStandardVerification'),
            finishCondition: 'GET STANDARD_VERIFICATION REQUEST',
        },
    ],
};

const totalStationVerification: WorkflowProcesses = {
    processes: [
        {
            process: 'getTotalStationVerification',
            startCondition: 'GET TOTALSTATION_VERIFICATION REQUEST',
            finishCondition: 'GET TOTALSTATION_VERIFICATION RESPONSE',
        },
    ],
};

const waitForTotalStationVerification: WorkflowProcesses = {
    processes: [
        {
            process: 'waitForTotalStationVerification',
            startCondition: createWindowFunctionCondition('waitForTotalStationVerification'),
            finishCondition: 'GET TOTALSTATION_VERIFICATION REQUEST',
        },
    ],
};

// For using the next two workflows, comment getScanTargetWorkflow
const sendScanTargetWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'sendScanTarget',
            startCondition: createWindowFunctionCondition('sendScanTarget'),
            finishCondition: 'GET SCAN_TARGET RESPONSE',
        },
    ],
};

const sendScanTargetWorkflowFail: WorkflowProcesses = {
    processes: [
        {
            process: 'sendScanTargetFail',
            startCondition: createWindowFunctionCondition('sendScanTargetFail'),
            finishCondition: 'GET SCAN_TARGET RESPONSE',
        },
    ],
};

const sendScanTargetWorkflow2: WorkflowProcesses = {
    processes: [
        {
            process: 'sendScanTarget2',
            startCondition: createWindowFunctionCondition('sendScanTarget2'),
            finishCondition: 'GET SCAN_TARGET2 RESPONSE',
        },
    ],
};

const getScanTargetWorkflow2: WorkflowProcesses = {
    processes: [{ process: 'getScanTarget2', startCondition: 'GET SCAN_TARGET2 REQUEST', finishCondition: 'GET SCAN_TARGET2 RESPONSE' }],
};

const waitForTransferStationRequestWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'waitForTransferStationRequest',
            startCondition: createWindowFunctionCondition('waitForTransferStationRequest'),
            finishCondition: 'GET TRANSFER_STATION_DATA REQUEST',
        },
    ],
};

const setCurrentStationWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'setCurrentStation',
            startCondition: createWindowFunctionCondition('setCurrentStation'),
            finishCondition: 'SET CURRENT_STATION RESPONSE',
        },
    ],
};

const setCurrentStationWorkflowFail: WorkflowProcesses = {
    processes: [
        {
            process: 'setCurrentStationFail',
            startCondition: createWindowFunctionCondition('setCurrentStationFail'),
            finishCondition: 'SET CURRENT_STATION RESPONSE',
        },
    ],
};

const getScanCloudWorkflow: WorkflowProcesses = {
    processes: [{ process: 'getScanCloud', startCondition: 'GET SCAN_CLOUD REQUEST', finishCondition: 'GET SCAN_CLOUD RESPONSE' }],
};

const getWindowScanCloudWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'getWindowScanCloud',
            startCondition: 'GET WINDOW_SCAN_CLOUD REQUEST',
            finishCondition: 'GET WINDOW_SCAN_CLOUD RESPONSE',
        },
    ],
};

const getScanCloudWorkflowFail: WorkflowProcesses = {
    processes: [
        {
            process: 'getScanCloudFail',
            startCondition: createWindowFunctionCondition('scanCloudFail'),
            finishCondition: 'GET SCAN_CLOUD RESPONSE',
        },
    ],
};

const getScanTargetWorkflow: WorkflowProcesses = {
    processes: [{ process: 'getScanTarget', startCondition: 'GET SCAN_TARGET REQUEST', finishCondition: 'GET SCAN_TARGET RESPONSE' }],
};

const getScanCloudAndResection: WorkflowProcesses = {
    processes: [
        {
            process: 'getScanCloudAndResection',
            startCondition: 'GET SCAN_CLOUD_AND_RESECTION REQUEST',
            finishCondition: 'GET SCAN_CLOUD_AND_RESECTION RESPONSE',
        },
    ],
};
const getMultiScanCloudWorkflow: WorkflowProcesses = {
    processes: [
        { process: 'getMultiScanCloud', startCondition: 'GET MULTI_SCAN_CLOUD REQUEST', finishCondition: 'GET MULTI_SCAN_CLOUD RESPONSE' },
    ],
};

const getTransferStationWorkflow: WorkflowProcesses = {
    processes: [
        {
            process: 'getTransferStation',
            startCondition: 'GET TRANSFER_STATION_DATA REQUEST',
            finishCondition: 'GET TRANSFER_STATION_DATA RESPONSE',
        },
    ],
};

// To use this workflow, comment the previous one or change its startCondition to startCondition: createWindowFunctionCondition( 'transferStation' )
const getTransferStationWorkflowFail: WorkflowProcesses = {
    processes: [
        {
            process: 'getTransferStationFail',
            startCondition: createWindowFunctionCondition('transferStationFail'),
            finishCondition: 'GET TRANSFER_STATION_DATA RESPONSE',
        },
    ],
};

const getStationTransformation: WorkflowProcesses = {
    processes: [
        {
            process: 'stationTransformations',
            startCondition: createWindowFunctionCondition('startStationTransformations'),
            finishCondition: 'GET STATIONS_TRANSFORMATIONS RESPONSE',
        },
    ],
};

const startReportPickPoint: WorkflowProcesses = {
    processes: [
        {
            process: 'startReportPickPoint',
            startCondition: createWindowFunctionCondition('startReportPickPoint'),
            finishCondition: 'GET REPORT_PICK_POINT RESPONSE',
        },
    ],
};

const stopReportPickPoint: WorkflowProcesses = {
    processes: [
        {
            process: 'stopReportPickPoint',
            startCondition: createWindowFunctionCondition('stopReportPickPoint'),
            finishCondition: 'GET REPORT_PICK_POINT RESPONSE',
        },
    ],
};

const waitForNotifyNavigationView: WorkflowProcesses = {
    processes: [
        {
            process: 'waitForNotifyNavigationView',
            startCondition: createWindowFunctionCondition('waitForNotifyNavigationView'),
            finishCondition: 'SET LAYOUT_NAVIGATION_VIEW RESPONSE',
        },
    ],
};

const setPrismPolePosition: WorkflowProcesses = {
    processes: [
        {
            process: 'setPrismPolePosition',
            startCondition: createWindowFunctionCondition('sendPrismPolePosition'),
            finishCondition: 'SET PRISM_POLE_POSITION RESPONSE',
        },
    ],
};

const waitForColumnSize: WorkflowProcesses = {
    processes: [
        {
            process: 'waitForColumnSize',
            startCondition: createWindowFunctionCondition('waitForColumnSize'),
            finishCondition: 'SET RIGHT_COLUMN_SIZE RESPONSE',
        },
    ],
};

const getFileContentsResponse: WorkflowProcesses = {
    processes: [
        {
            process: 'getFileContents',
            startCondition: createWindowFunctionCondition('getFileContents'),
            finishCondition: 'ACTION GET_FILE_CONTENTS RESPONSE',
        },
    ],
};

const getFileContentsResponseCloseDialog: WorkflowProcesses = {
    processes: [
        {
            process: 'getFileContentsCloseDialog',
            startCondition: createWindowFunctionCondition('getFileContentsCloseDialog'),
            finishCondition: 'ACTION GET_FILE_CONTENTS RESPONSE',
        },
    ],
};

const getFileContentsResponsePathError: WorkflowProcesses = {
    processes: [
        {
            process: 'getFileContentsPathError',
            startCondition: createWindowFunctionCondition('getFileContentsPathError'),
            finishCondition: 'ACTION GET_FILE_CONTENTS RESPONSE',
        },
    ],
};

const getTransferStationDataQueuedResponse: WorkflowProcesses = {
    processes: [
        {
            process: 'getTransferStationDataQueuedResponse',
            startCondition: createWindowFunctionCondition('getTransferStationDataQueuedResponse'),
            finishCondition: 'GET TRANSFER_STATION_DATA_QUEUED RESPONSE',
        },
    ],
};

const getCopyCompressFilesResponse: WorkflowProcesses = {
    processes: [
        {
            process: 'getCopyCompressFilesResponse',
            startCondition: createWindowFunctionCondition('getCopyCompressFilesResponse'),
            finishCondition: 'ACTION COPY_AND_COMPRESS_FILES RESPONSE',
        },
    ],
};

/* Include here every workflow to load it */
export const workflowMocks: WorkflowProcesses[] = [
    userPreferencesWorkflow,
    boundingWorkflow,
    pivotPointWorkflow,
    projectNameWorkflow,
    notifyWorkflowStateWorkflow,
    waitForNotifyWorkflowStateWorkflow,
    notifyScannerStateWorkflow,
    addNewStationWorkflow,
    addNewLayoutPoint,
    waitForStandardVerification,
    totalStationVerification,
    waitForTotalStationVerification,
    sendScanTargetWorkflow,
    sendScanTargetWorkflow2,
    waitForTransferStationRequestWorkflow,
    setCurrentStationWorkflow,
    getScanCloudWorkflow,
    getWindowScanCloudWorkflow,
    getScanTargetWorkflow,
    getScanTargetWorkflow2,
    getTransferStationWorkflow,
    instrumentHeightWorkflow,
    getScannerStateWorkflow,
    getStationTransformation,
    stationPositionWorkflow,
    notifyScannerStateWorkflowFail,
    instrumentHeightWorkflowFail,
    sendScanTargetWorkflowFail,
    setCurrentStationWorkflowFail,
    addNewStationWorkflowFail,
    getScanCloudWorkflowFail,
    getTransferStationWorkflowFail,
    projectDataWorkflow,
    addNewStationManuallyWorkflow,
    startReportPickPoint,
    stopReportPickPoint,
    waitForNotifyNavigationView,
    setPrismPolePosition,
    getScanCloudAndResection,
    getMultiScanCloudWorkflow,
    waitForColumnSize,
    getFileContentsResponse,
    getFileContentsResponseCloseDialog,
    getFileContentsResponsePathError,
    getTransferStationDataQueuedResponse,
    getCopyCompressFilesResponse,
];
